import { render, staticRenderFns } from "./DeviceModel.vue?vue&type=template&id=164703d7&scoped=true"
import script from "./DeviceModel.vue?vue&type=script&lang=js"
export * from "./DeviceModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164703d7",
  null
  
)

export default component.exports